import { getData } from './script_data.js';

let _paywallConfig = undefined;

// Although the ApplicationController adds this when possible on the server side, we still need this for content rendered on the client side.
export function addLinkPaywallClasses() {
  const paywallConfig = getPaywallConfig();
  if (!document.querySelector('#paywall-structured-data') || !paywallConfig) {
    return;
  }

  for (let root of [document].concat(_getShadowRoots(document.body, paywallConfig.exemptSelectors))) {
    _addLinkPaywallClassesToRoot(root, paywallConfig.interactiveSelector);
  }
}

function _addLinkPaywallClassesToRoot(root, interactiveSelector) {
  const links = root.querySelectorAll(interactiveSelector);
  for (let link of links) {
    link.classList.add('paywall');
  }
}

function _getShadowRoots(body, exemptSelectors) {
  return [body, ...body.querySelectorAll('*')]
    .filter(element => !!element.shadowRoot)
    .filter(element => !exemptSelectors.some(s => element.matches(s)))
    .flatMap(element => [element.shadowRoot, ..._getShadowRoots(element.shadowRoot, exemptSelectors)]);
}

export function getPaywallConfig() {
  if (_paywallConfig !== undefined) {
    return _paywallConfig;
  }

  const paywallConfig = getData('paywall-config');
  if (!paywallConfig) {
    _clearPaywallConfig();
    return null;
  }

  const paywallInteractiveTags = Array.isArray(paywallConfig.paywall_interactive_tags) ? paywallConfig.paywall_interactive_tags : [];
  const paywallExemptSelectors = Array.isArray(paywallConfig.paywall_exempt_selectors) ? paywallConfig.paywall_exempt_selectors : [];
  const exemptSelectorSuffix = paywallExemptSelectors.length > 0 ? `:not(:is(${paywallExemptSelectors.join(', ')}))` : '';
  const interactiveSelector = `:is(${paywallInteractiveTags.join(', ')})${exemptSelectorSuffix}`;

  _paywallConfig = {
    interactiveSelector: interactiveSelector,
    exemptSelectors: paywallExemptSelectors,
    exemptedPaywallClassPaths: paywallConfig.exempted_paywall_class_paths,
    maxNumClicksThreshold: paywallConfig.max_num_clicks_threshold
  };

  return _paywallConfig;
}

function _clearPaywallConfig() {
  _paywallConfig = undefined;
}
